<template>
  <v-app>
    <v-main class="main">

      <!-- Sidebar -->

      <!-- <Sidebar :collapsed="isSidebarCollapsed" /> -->
      <Sidebar :drawerOpen="drawerOpen" :collapsed="isSidebarCollapsed" :isMobile="isMobile"
        @update:drawerOpen="drawerOpen = $event" />


      <!-- Main content -->
      <v-container fluid class="main-content pa-4">

        <!-- Header -->
        <Header :isDarkMode="isDarkMode" :isMobile="isMobile" @toggle-sidebar="toggleSidebar"
          @toggle-darkmode="toggleDarkMode" />

        <div class="content">

          <v-toolbar-title class="welcome-title text-left">Hello, {{ firstName }} {{ lastName }}</v-toolbar-title>



          <!-- Stat Cards -->
          <v-row class="stats mt-4 mb-8" dense>
            <div v-if="userLoaded && showKycBanner" class="kyc-banner">
              <p>
                ⚠️ Your account is unverified. Complete your KYC to continue using all features.
              </p>

              <button @click="openKycModal" class="kyc-btn">
                Complete Verification
              </button>
            </div>
            <!-- <GlobalKyc /> -->

            <!--Desktop view-->
            <v-col cols="12" md="6" sm="auto" class="pe-md-3 d-none d-md-block" :key="walletCardKey">
              <DashCard title="Wallet Balance" :value="formatCurrency(walletBalance)"
                :subtext="`Account: ${bank} ${v_nuban}`" @open-funding="openFundingModal" @reload-user="reloadUserData"
                @open-withdrawal="withdrwalModal" />
            </v-col>
            <v-col cols="12" md="6" sm="auto" class="ps-md-3 d-none d-md-block">
              <PortfolioCard title="Portfolio Overview" :value="formatCurrency(totalPortfolioValue)"
                :legacy="formatCurrency(investmentBalance)" />
            </v-col>

            <!--Mobile Card Carousel-->
            <v-col cols="12" class="d-md-none" :key="walletCardKey">
              <v-carousel hide-delimiter-background hide-delimiters="false" show-arrows="false" height="auto" cycle
                continuous>
                <v-carousel-item>
                  <DashCard title="Wallet Balance" :value="formatCurrency(walletBalance)"
                    :subtext="`Account: ${bank} ${v_nuban}`" @open-funding="walletFundingModal = true"
                    @reload-user="reloadUserData" @open-withdrawal="withdrwalModal" />
                </v-carousel-item>

                <v-carousel-item>
                  <PortfolioCard title="Portfolio Overview" :value="formatCurrency(totalPortfolioValue)"
                    :legacy="formatCurrency(investmentBalance)" />
                </v-carousel-item>
              </v-carousel>
            </v-col>

          </v-row>

          <v-row class="g-4 mt-4 mb-8" dense>
            <!-- Cards Column -->
            <v-col cols="12" md="6" class="pe-md-3">
              <!-- Column Title -->
              <div class="column-title mb-6">
                <h5 class="m-0 text-left">Quick Links</h5>
                <hr class="title-separator" />
              </div>
              <!-- Outer Card wrapping 4 inner cards -->
              <v-card class="outer-card" flat>
                <v-row dense class="g-2" style="height: 100%; padding: 16px;">
                  <v-col v-for="(panel, index) in panels" :key="index" cols="6" class="py-1 px-1" style="height: 50%;">
                    <!-- Inner Card -->
                    <v-card class="inner-card pa-3 w-100 h-100" flat>
                      <!-- Header -->
                      <div class="d-flex align-center mb-2">
                        <Avatar :image="panel.avatar" shape="circle" style="width: 64px; height: auto;" />
                      </div>

                      <!-- Title + Icon -->
                      <h4 class="text-left font-weight-bold mb-2 clickable-title" @click="router.push(panel.route)">
                        {{ panel.title }}
                        <v-icon class="ms-2 icon-mobile" :color="panel.color" size="16">
                          {{ panel.icon }}
                        </v-icon>
                      </h4>

                      <!-- Description (hidden on mobile) -->
                      <p class="m-0 d-none d-sm-block text-left small-text text-grey">
                        {{ panel.description }}
                      </p>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>

            <!-- Transaction Column -->
            <v-col cols="12" md="6" class="ps-md-3">
              <div class="column-title mb-6">
                <h5 class="m-0 text-left">Recent Transactions</h5>
                <hr class="title-separator" />
              </div>
              <v-card class="outer-card chart-wrapper" flat>
                <v-card class="pa-3 inner-transaction-card" flat>

                  <template v-for="(tx, index) in recentTransactions" :key="tx.uuid">

                    <!-- ROW -->
                    <div class="d-flex justify-space-between align-center py-2">

                      <!-- LEFT SIDE -->
                      <div class="d-flex align-center">

                        <!-- Icon -->
                        <!-- <v-icon :color="isDebit(tx) ? 'red' : 'green'" size="28">
                          {{ isDebit(tx)
                            ? 'mdi-arrow-top-right-bold-box'
                            : 'mdi-arrow-bottom-left-bold-box'
                          }}
                        </v-icon> -->
                        <TransactionIcon :debit="isDebit(tx)" :size="28" />

                        <!-- Text -->
                        <div class="ms-3 text-left">
                          <div class="font-weight-medium text-body-2 text-capitalize">
                            {{ formatTitle(tx.type) }}
                          </div>

                          <div class="text-caption text-grey">
                            {{ tx.description }}
                          </div>
                        </div>

                      </div>

                      <!-- RIGHT SIDE -->
                      <div class="text-right">

                        <!-- Amount -->
                        <div class="font-weight-medium text-body-2" :class="isDebit(tx) ? 'text-red' : 'text-green'">
                          {{ isDebit(tx) ? '-' : '+' }}{{ formatCurrency(tx.amount) }}
                        </div>

                        <!-- Date -->
                        <div class="text-caption text-grey">
                          {{ formatDateTime(tx.created_at) }}
                        </div>

                      </div>
                    </div>

                    <!-- Divider (only between items) -->
                    <v-divider v-if="index !== recentTransactions.length - 1" />

                  </template>

                </v-card>

              </v-card>

            </v-col>
          </v-row>




          <v-row class="g-4 mt-4 mb-8" dense>

            <v-col cols="12" sm="12">
              <div class="column-title mb-6">
                <h5 class="m-0 text-left">Featured Opportunities</h5>
                <hr class="title-separator" />
              </div>
            </v-col>

            <!-- Product Cards -->
            <v-col v-for="(product, index) in products" :key="index" cols="12" md="4" class="pa-2">
              <v-card class="product-card pa-6 h-100" flat>

                <!-- TOP: Logo + Name -->
                <div class="d-flex align-center gap-2 mb-4">
                  <img :src="product.product_image ? `${STORAGE_URL}/${product.product_image}` : defaultImage"
                    class="product-image" />
                  <div class="text-left">
                    <div class="font-weight-bold text-body-1">
                      {{ product.product_name }}
                    </div>
                    <div class="text-caption text-grey">
                      {{ product.partner.name }}
                    </div>
                  </div>
                </div>

                <!-- INNER CARD -->
                <v-card class="inner-mini-card pa-2 mb-3" flat>
                  <div class="d-flex justify-space-between">

                    <!-- LEFT: Maturity -->
                    <div class="text-left">
                      <div class="text-caption text-grey">Maturity Date</div>
                      <div class="font-weight-medium">
                        {{ formatDate(product.maturity_date) }}
                      </div>
                    </div>

                    <!-- RIGHT: Rate -->
                    <div class="text-right">
                      <div class="text-caption text-grey">Rate</div>
                      <div class="font-weight-medium text-green">
                        {{ formatNumber(product.interest) }}%
                      </div>
                    </div>

                  </div>
                </v-card>

                <!-- BOTTOM ROW -->
                <div class="d-flex justify-space-between align-center mt-auto">

                  <!-- Risk -->
                  <div class="text-caption">
                    <span :class="getRiskClass(product.risk_category.name)">
                      {{ product.risk_category.name }}
                    </span>
                  </div>

                  <!-- View Details -->
                  <div class="d-flex align-center gap-2">
                    <span class="text-caption font-weight-medium clickable-title"
                      @click="viewProductDetails(product.product_id)">
                      View Details
                    </span>
                    <v-icon size="16" class="ms-1">mdi-arrow-right-circle</v-icon>
                  </div>

                </div>

              </v-card>
            </v-col>

          </v-row>
        </div>
      </v-container>

      <!-- KYC Modal -->
      <v-dialog v-model="kycModal" max-width="500" :eager="true">
        <v-card class="pa-4">
          <form @submit.prevent="submitKyc" class="w-full space-y-6">
            <h3 class="text-lg font-bold mb-4">KYC Verification</h3>

            <!-- BVN -->
            <div class="field mb-4">
              <label>BVN</label>
              <input v-model="kycForm.bvn" type="text" class="modern-input" />
            </div>

            <!-- BVN -->
            <div class="field mb-4">
              <label>Account Number</label>
              <input v-model="kycForm.acctNo" type="text" class="modern-input" />
            </div>

            <!--Bank-->
            <div class="field mb-4">
              <label>Bank</label>

              <v-autocomplete v-model="selectedBank" :items="banks || []" item-title="name" variant="outlined"
                return-object label="Select Bank" placeholder="Search bank..." clearable hide-no-data />
            </div>

            <!-- NIN -->
            <div class="field mb-4">
              <label>NIN</label>
              <input v-model="kycForm.nin" type="text" class="modern-input" />
            </div>

            <!-- TIN -->
            <!-- <div class="field mb-4">
              <label>TIN</label>
              <input v-model="kycForm.tin" type="text" class="modern-input" />
            </div> -->

            <div v-if="kycStatus" class="flex justify-center">

              <!-- <span v-if="kycStatus.type === 'success'"
                class="inline-flex items-center px-3 py-1 rounded-full text-sm !bg-green-100 text-green-700"
                style="color: #15803d; background: #dcfce7; ">
                ✔ {{ kycStatus.message }}
              </span>

              <span v-else class="inline-flex items-center px-3 py-1 rounded-full text-sm bg-red-100 text-red-700"
                style="color: #b91c1c; background: #fee2e2;">
                ✖ {{ kycStatus.message }}
              </span> -->
              <v-alert v-if="kycStatus" :type="kycStatus.type" density="compact" variant="tonal" class="text-center">
                {{ kycStatus.message }}
              </v-alert>
            </div>
            <v-card-actions class="justify-center gap-6 mt-4">

              <button @click="kycModal = false"
                class="px-4 py-2 rounded-md border border-gray-300 text-gray-600 hover:bg-gray-100 transition">
                Cancel
              </button>

              <button @click="submitKyc" :disabled="kycLoading"
                class="px-5 py-2 rounded-md bg-black text-white font-semibold transition-colors duration-300 hover:bg-green-600 flex items-center gap-2">
                <span>{{ kycLoading ? 'Verifying...' : 'Verify Me' }} </span>
                <v-icon v-if="kycLoading" class="spin"> mdi-loading</v-icon>
              </button>

            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>

      <!-- Wallet Funding Modal -->
      <v-dialog v-model="walletFundingModal" max-width="500">
        <v-card class="inner-card flex-grow-1" flat>
          <div class="d-flex flex-column align-center justify-center pa-6 w-100 h-100">

            <h3 class="mt-4 mb-2">Wallet Funding <!--v-icon size="28"
                color="green">mdi-arrow-bottom-left-bold-box-outline</v-icon--></h3>
            <p class="text-center text-caption text-grey mb-6">
              To add money, please transfer funds to your unique account number provided below. Your wallet will be
              credited
              once the transfer is confirmed.
            </p>

            <div class="bg-gray-100 border border-gray-300 rounded-md px-4 py-3  text-center relative"
              style="width: 100%; max-width: 500px;">
              <div class="text-caption text-grey">Bank Name</div>
              <div class="font-mono font-semibold text-lg mb-6">
                {{ bank }}
              </div>

              <div class="text-caption text-grey">Account Number</div>
              <div class="font-mono font-semibold text-lg mb-6">
                {{ v_nuban }}
                <v-icon size="18" class="absolute top-2 right-2 cursor-pointer hover:opacity-70"
                  @click="copyToClipboard(`${v_nuban}`)">
                  {{ copied ? 'mdi-check' : 'mdi-content-copy' }}
                </v-icon>
              </div>


              <div class="text-caption text-grey">Account Name</div>
              <div class="font-mono font-semibold text-lg mb-6">
                {{ v_nuban_name }}
              </div>

              <button @click="confirmTransfer" :disabled="checkingPayment || !String(v_nuban).trim()"
                class="mt-6 px-5 py-2 action-button text-white font-semibold transition-colors duration-300 hover:bg-green-600 mb-3">
                {{ checkingPayment ? 'Checking payment...' : 'I have sent the money' }}
              </button>
              <p class="text-center text-caption text-grey-darken-1 opacity-70 mb-6">
                Please note that it takes a few minutes to get the funds in your wallet
              </p>
            </div>
          </div>

        </v-card>
      </v-dialog>

      <!-- Withdraw Modal -->




      <v-dialog v-model="withdrawDialog" max-width="520">
        <v-card rounded="lg">
          <v-card-title class="text-h6 font-weight-bold">
            Send Money
          </v-card-title>

          <!-- User NOT verified -->
          <template v-if="!isVerified">
            <v-card-text>
              <v-alert type="info" variant="tonal" density="comfortable" class="mt-4">
                You need to complete your verification before you can make withdrawals.
              </v-alert>

              <v-card-actions>
                <v-btn color="black" @click="withdrawDialog = false" class="mt-4">
                  Close
                </v-btn>
              </v-card-actions>
            </v-card-text>
          </template>

          <!-- User verified -->
          <template v-else>

            <v-card-text>
              <div v-if="withdrawStep === 1">
                <!-- Destination Account -->
                <v-sheet border rounded="lg" class="pa-4 mb-5 bg-grey-lighten-5">
                  <div class="text-subtitle-2 font-weight-medium mb-3">
                    Destination
                  </div>

                  <v-row dense>
                    <v-col cols="12">
                      <div class="text-caption text-grey">
                        Account Name
                      </div>
                      <div class="font-weight-medium">
                        {{ real_nuban_name }}
                      </div>
                    </v-col>

                    <v-col cols="12">
                      <div class="text-caption text-grey">
                        Account Number
                      </div>
                      <div class="font-weight-medium">
                        {{ real_nuban }}
                      </div>
                    </v-col>

                    <v-col cols="12">
                      <div class="text-caption text-grey">
                        Bank
                      </div>
                      <div class="font-weight-medium">
                        {{ real_bank }}
                      </div>
                    </v-col>
                  </v-row>
                </v-sheet>

                <!-- Amount -->
                <v-text-field v-model="withdrawAmount" label="Amount to Send" type="number"
                  prepend-inner-icon="mdi-cash" prefix="₦" variant="outlined" density="comfortable"
                  :error-messages="withdrawError" />

                <!-- PIN appears after a valid amount -->
                <v-expand-transition>
                  <div v-if="showPinField" class="mt-4">

                    <div class="text-subtitle-2 mb-2">
                      Enter Transaction PIN
                    </div>

                    <div class="pin-container">
                      <input v-for="(digit, index) in withdrawPin" :key="index" v-model="withdrawPin[index]"
                        type="password" maxlength="1" class="pin-box" @input="handlePinInput($event, index)"
                        @keydown="handlePinKeydown($event, index)" />
                    </div>
                  </div>
                </v-expand-transition>

                <v-alert type="info" variant="tonal" density="comfortable" class="mt-4">
                  The transfer request is pending approval and will be settled to
                  your bank account within 24hrs. You will be notified as soon as
                  this is completed
                </v-alert>

              </div>
              <div v-else>

                <v-alert type="warning" variant="tonal" class="mb-4">
                  Please review your withdrawal before confirming.
                </v-alert>

                <v-sheet border rounded="lg" class="pa-4 mb-4">

                  <div class="d-flex justify-space-between mb-2">
                    <span>Amount</span>
                    <strong>₦{{ Number(withdrawAmount).toLocaleString() }}</strong>
                  </div>

                  <div class="d-flex justify-space-between mb-2">
                    <span>Transaction charge</span>
                    <strong>₦{{ Number(transactionCharge).toLocaleString() }}</strong>
                  </div>

                  <div class="d-flex justify-space-between mb-2">
                    <span>Bank</span>
                    <strong>{{ real_bank }}</strong>
                  </div>

                  <div class="d-flex justify-space-between">
                    <span>Account</span>
                    <strong>{{ real_nuban }}</strong>
                  </div>

                </v-sheet>

                <div class="mb-2 font-weight-medium pin-title">
                  Enter Transaction PIN
                </div>
                <div class="pin-subtitle">
                  Enter your 6-digit PIN to authorize this withdrawal.
                </div>

                <div class="pin-container">
                  <input v-for="(digit, index) in withdrawPin" :key="index" v-model="withdrawPin[index]" type="password"
                    maxlength="1" class="pin-box" @input="handleWithdrawPinInput($event, index)"
                    @keydown="handleWithdrawPinKeydown($event, index)" />
                </div>
                <!-- <v-alert
                v-if="withdrawPinError"
                type="error"
                variant="tonal"
                density="comfortable"
                class="mt-3"
              >
                {{ withdrawPinError }}
              </v-alert> -->
                <v-slide-y-transition>
                  <v-sheet v-if="withdrawPinError" class="withdraw-error pa-4 mb-4" rounded="xl" elevation="1">
                    <div class="d-flex align-center">

                      <v-icon color="error" size="28" class="mr-3">
                        mdi-shield-alert-outline
                      </v-icon>

                      <div>
                        <div class="font-weight-bold">
                          Withdrawal could not be processed
                        </div>

                        <div class="text-body-2 mt-1">
                          {{ withdrawPinError }}
                        </div>
                      </div>

                    </div>
                  </v-sheet>
                </v-slide-y-transition>
              </div>
            </v-card-text>

            <v-card-actions>

              <v-btn variant="text" @click="withdrawStep === 1 ? withdrawDialog = false : withdrawStep = 1">
                {{ withdrawStep === 1 ? 'Cancel' : 'Back' }}
              </v-btn>

              <v-spacer />

              <v-btn v-if="withdrawStep === 1" color="black" @click="continueWithdrawal">
                Continue
              </v-btn>

              <v-btn v-else color="black" :loading="withdrawLoading" :disabled="!canWithdraw" @click="handleWithdraw">
                Confirm Withdrawal
              </v-btn>

            </v-card-actions>
          </template>
        </v-card>

      </v-dialog>

      <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" location="top right"> {{
        snackbar.message }}
        <template #actions>
          <v-btn variant="text" @click="snackbar.show = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref, onMounted, onUnmounted, computed, reactive, watch } from "vue"
import Sidebar from "@/components/Sidebar.vue"
import Header from "@/components/Header.vue"
import DashCard from "@/components/DashCard.vue"
import { useRouter } from "vue-router"
import { useDashStore } from "@/store/dashboard"
import { useTransactStore } from "@/store/transaction"
import { useInvStore } from "@/store/investment"
import { formatCurrency, formatDate, formatDateTime, formatTitle, formatNumber, getRiskClass, getAllErrors } from "@/util"
import { STORAGE_URL } from "@/api/http"
import { fetchBanks } from "@/api/dashboard"
import PortfolioCard from "@/components/PortfolioCard.vue"
import { executeWithdrawFunds } from "@/api/transaction"
import investImage from '@/assets/investment-elementor-io-optimized.webp'
import portfolioImage from '@/assets/portfolio-elementor-io-optimized.webp'
import transactImage from '@/assets/transactions-elementor-io-optimized.webp'
import helpImage from '@/assets/help_support-elementor-io-optimized.webp'
import TransactionIcon from "@/components/icons/TransactionIcon.vue"
import { performKyc } from "@/api/auth"
//import GlobalKyc from "@/components/GlobalKyc.vue"

const isSidebarCollapsed = ref(false)
const isDarkMode = ref(false)
const drawerOpen = ref(false)
const isMobile = ref(false)
const walletFundingModal = ref(false)
const withdrawDialog = ref(false)
const withdrawAmount = ref("")
const withdrawLoading = ref(false)
const withdrawError = ref("")
//const isUserLoaded = ref(false)
const walletCardKey = ref(0)
const checkingPayment = ref(false)
const withdrawStep = ref(1)
const withdrawPin = ref(["", "", "", "", "", ""])
const transactionCharge = 53


//pinia store
const dash = useDashStore()
const trn = useTransactStore()
const router = useRouter()
const defaultImage = "https://gravatar.com/avatar/"
const port = useInvStore()

/**============= handle Header emits ============*/
const toggleSidebar = () => {
  if (isMobile.value) {
    // On mobile: open/close drawer
    drawerOpen.value = !drawerOpen.value
  } else {
    // On desktop: collapse/expand sidebar
    isSidebarCollapsed.value = !isSidebarCollapsed.value
  }
}

const checkMobile = () => {
  isMobile.value = window.innerWidth < 768
  if (!isMobile.value) drawerOpen.value = true // desktop always open
  else drawerOpen.value = false                 // mobile closed by default
}

const toggleDarkMode = () => {
  isDarkMode.value = !isDarkMode.value
}

const reloadUserData = async () => {
  await dash.loadUser()

  walletCardKey.value++
}


const walletBalance = computed(() => dash.user?.user?.wallet?.balance || 0)
const v_nuban = computed(() => dash.user?.user?.profile?.v_bank_number || '')
const v_nuban_name = computed(() => dash.user?.user?.profile?.v_bank_acct_name || '')
const bank = computed(() => dash.user?.user?.profile?.v_bank_name || '')
const firstName = computed(() => dash.user?.user?.profile.firstname || '')
const lastName = computed(() => dash.user?.user?.profile.lastname || '')

const real_nuban = computed(() => dash.user?.user?.profile?.nuban || '')
const real_nuban_name = computed(() => dash.user?.user?.profile?.nuban_account_name || '')
const real_bank = computed(() => dash.user?.user?.profile?.nuban_bank || '')
//const bank = computed(() => dash.user?.user?.profile.v_bank_name || '')
const transactions = computed(() => trn.transactions || [])
const walletId = computed(() => dash.user?.user?.wallet?.uuid)

const products = computed(() =>
  (dash.products || []).filter(p => p.featured === true)
)

const recentTransactions = computed(() => {
  return transactions.value?.slice(0, 6) ?? []
})

const portfolios = computed(() => port.portfolios?.portfolio_data || [])


const totalInvested = computed(() => {
  return portfolios.value.reduce((sum, p) => sum + Number(p.total_invested || 0), 0)
})

const totalYield = computed(() => {
  return portfolios.value.reduce((sum, p) => sum + Number(p.total_accumulated_yield || 0), 0)
})

const totalPortfolioValue = computed(() =>
  totalInvested.value + totalYield.value
)

const isDebit = (tx) => {
  return ['debit', 'investment', 'withdrawal'].includes(tx.type)
}


const loading = ref(true)

onMounted(async () => {
  checkMobile()
  window.addEventListener("resize", checkMobile)
  await dash.loadUser()
  await trn.loadTransaction()
  await dash.loadProduct();
  await port.loadPortfolioSummary()
  userLoaded.value = true
  loadBanks()
  loading.value = false
});

const panels = [
  {
    avatar: investImage,
    title: 'Invest Money',
    icon: 'mdi-arrow-right-circle',
    color: 'green',
    description: 'Grow your wealth through diverse investment opportunities',
    route: '/investments'
  },
  {
    avatar: portfolioImage,
    title: 'View Portfolio',
    icon: 'mdi-arrow-right-circle',
    color: 'orange',
    description: 'Easily check your investments and portfolio performance',
    route: '/portfolio'
  },
  {
    avatar: transactImage,
    title: 'Transactions',
    icon: 'mdi-arrow-right-circle',
    color: 'blue',
    description: 'Track all your financial transactions in one place',
    route: '/transactions'
  },
  {
    avatar: helpImage,
    title: 'Help & Support',
    icon: 'mdi-arrow-right-circle',
    color: 'red',
    description: 'Get assistance and answers to all your questions quickly',
    route: '/settings'
  }
]

/** User KYC */
const kycModal = ref(false)
const userLoaded = ref(false)
const isUserLoaded = computed(() => !!dash.user?.user?.profile)

const showKycBanner = computed(() => {
  if (!isUserLoaded.value) return false

  const status = dash.user.user.profile.verification_status

  return String(status ?? "").trim().toLowerCase() !== "completed"
})

const openKycModal = () => {
  kycModal.value = true
}

const kycForm = reactive({
  bvn: '',
  nin: '',
  tin: '',
  dob: ''
})

//snack bar notification
const snackbar = ref({
  show: false,
  message: "",
  color: "success" // success | error | warning | info
})

const showSnackbar = (message, color = "success") => {
  snackbar.value.message = message
  snackbar.value.color = color
  snackbar.value.show = true
}

watch(
  () => dash.user,
  (val) => {
    const profile = val?.user?.profile

    if (profile?.dob) {
      kycForm.dob = profile.dob
    }
  },
  (val) => {
    if (val) {
      isUserLoaded.value = true
    }
  },
  { immediate: true }
)

//Load banks for dropdown
const banks = ref([])
const selectedBank = ref(null)

const loadBanks = async () => {
  try {
    const res = await fetchBanks()

    // adjust depending on your API structure
    banks.value = res?.data?.data?.data || []
  } catch (e) {
    console.error(e)
    banks.value = []
  }
}

//Perform KYC submission
const kycLoading = ref(false)
const kycStatus = ref(null)

const submitKyc = async () => {
  //console.log("Selected bank:", selectedBank.value)

  kycLoading.value = true
  try {
    const res = await performKyc({
      bvn: kycForm.bvn,
      nin: kycForm.nin,
      //tin: kycForm.tin,
      firstname: firstName.value,
      lastname: lastName.value,
      email: dash.user?.user?.email,
      phone: dash.user?.user?.mobile_number,
      account_number: kycForm.acctNo,
      bank_code: selectedBank.value?.code,
      bank: selectedBank.value?.name
    })

    const accountName = res.data.data?.account_name || ''
    const accountNumber = res.data.data?.account_number || ''
    //const bankName = selectedBank.value?.name || ''

    kycStatus.value = {
      type: "success",
      message: `${accountName} - ${accountNumber} - Verified`
    }
    //kycModal.value = false
    await dash.loadUser() // refresh user data to get updated KYC status
  } catch (e) {
    const msg = getAllErrors(e)
    kycStatus.value = {
      type: "error",
      message: msg || "KYC verification failed"
    }
  } finally {
    kycLoading.value = false
  }
}

/** User KYC end */

const viewProductDetails = (id) => {
  router.push(`/product-detail/${id}`)
}

onUnmounted(() => {
  window.removeEventListener("resize", checkMobile)
})


//Confirm transfer
const confirmTransfer = async () => {
  checkingPayment.value = true

  const oldBalance = walletBalance.value || 0

  let attempts = 0

  const interval = setInterval(async () => {
    attempts++

    await dash.loadUser()

    const newBalance = dash.user?.user?.wallet?.balance || 0

    // balance updated
    if (newBalance > oldBalance) {
      clearInterval(interval)

      walletFundingModal.value = false

      checkingPayment.value = false

      showSnackbar("Wallet funded successfully", "success")
      //alert("Wallet funded successfully")

      return
    }

    // stop after 2 mins
    if (attempts >= 24) {
      clearInterval(interval)

      checkingPayment.value = false

      showSnackbar("Payment not detected yet. Please wait a little longer.", "error")
      //alert("Payment not detected yet. Please wait a little longer.")
    }

  }, 5000)
}

//trigger error if virtual account number not assigned yet
const openFundingModal = () => {
  if (!v_nuban.value || !String(v_nuban.value).trim()) {
    showSnackbar("Virtual account number not available yet", "error")
    return
  }

  walletFundingModal.value = true
}

//Copy nad paste
const copied = ref(null)
const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text)
    copied.value = text

    setTimeout(() => {
      copied.value = false
    }, 1500)
  } catch (err) {
    console.error(err)
  }
}

/**Withdrawal section starts */

const withdrwalModal = () => {
  withdrawDialog.value = true
}

const showPinField = computed(() => {
  return (
    withdrawAmount.value &&
    Number(withdrawAmount.value) > 0 &&
    Number(withdrawAmount.value) <= Number(walletBalance.value)
  )
})

const withdrawPinError = ref("")

const handleWithdraw = async () => {

  withdrawError.value = ""

  if (!withdrawAmount.value || withdrawAmount.value <= 0) {
    withdrawError.value = "Please enter a valid amount"
    return
  }

  withdrawLoading.value = true
  try {
    await executeWithdrawFunds({
      wallet_id: walletId.value,
      amount: Number(withdrawAmount.value),
      pin: withdrawPin.value.join("")
    })

    // ✅ SUCCESS MESSAGE
    showSnackbar("Withdrawal request sent successfully")

    withdrawDialog.value = false
    withdrawAmount.value = ""

  } catch (e) {

    withdrawPinError.value =
      e.response?.data?.message || "Withdrawal failed"

  } finally {
    withdrawLoading.value = false
  }
}

//watch for withdrawal pin
watch(withdrawDialog, (value) => {
  if (value) {
    withdrawStep.value = 1
    withdrawAmount.value = ""
    withdrawPin.value = ["", "", "", "", "", ""]
    withdrawError.value = ""
  }
})

const continueWithdrawal = () => {

  withdrawError.value = ""
  withdrawPinError.value = ""

  if (!withdrawAmount.value) {
    withdrawError.value = "Please enter a withdrawal amount."
    return
  }

  if (Number(withdrawAmount.value) <= 0) {
    withdrawError.value = "Amount must be greater than zero."
    return
  }

  if (Number(withdrawAmount.value) < 10000) {
    withdrawError.value = "Amount must not be less than 10000."
    return
  }

  if (Number(withdrawAmount.value) > Number(walletBalance.value)) {
    withdrawError.value = "Insufficient wallet balance."
    return
  }

  withdrawStep.value = 2
}

const canWithdraw = computed(() => {
  return (
    Number(withdrawAmount.value) > 0 &&
    withdrawPin.value.join("").length === 6
  )
})

const isVerified = computed(() => {
  return !!(
    real_nuban.value &&
    real_nuban_name.value &&
    real_bank.value
  )
})

const handleWithdrawPinInput = (event, index) => {
  const value = event.target.value.replace(/\D/g, "").slice(0, 1)

  withdrawPin.value[index] = value

  if (value && event.target.nextElementSibling) {
    event.target.nextElementSibling.focus()
  }
}

const handleWithdrawPinKeydown = (event, index) => {
  if (
    event.key === "Backspace" &&
    !withdrawPin.value[index] &&
    index > 0
  ) {
    event.target.previousElementSibling.focus()
  }
}

/**Withdrawal section ends */
</script>

<style scoped>
.main {
  display: flex;
  min-height: 100vh;
  /* font-family: sans-serif; */
}

.sidebar {
  background-color: #f3f4f6;
  padding: 20px;
}

.main-content {
  flex: 1;
  background-color: #f8fafc;
  padding-left: 5%;
  padding-right: 5%;
}

.content {
  padding-left: 10%;
  padding-right: 10%;
}

.large-box {
  min-height: 300px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  background-color: #fff;
}

/* Override v-card inside StatCard if needed */
.stats .v-card {
  text-align: center;
}

:deep(.modern-table .p-datatable-thead > tr > th) {
  background: #eef7f0;
  color: #065f46;
  font-weight: 600;
  border-bottom: 2px solid #c1edc3;
}

:deep(.modern-table .inner .p-datatable-thead > tr > th) {
  background: #ffffff;
  color: #065f46;
  font-weight: 600;
  border-bottom: 2px solid #c1edc3;
}

.welcome-title {
  margin-top: 2%;
  margin-bottom: 2%;
  font-size: 1.05rem;
  font-weight: 700;
}

.balance-card {
  background-color: #091c2a;
}

.icon-mobile {
  font-size: 20px;
}

/* Column title */
.column-title h5 {
  font-size: 1.1rem;
  font-weight: 400;
  margin-bottom: 2.5%;
}

/* Horizontal line below title */
.title-separator {
  border: none;
  height: 1px;
  background-color: #eae5e5;
  margin: 0;
  margin-bottom: 8px;
}

/* Outer card wrapping the 4 inner cards */
.outer-card {
  border: 1px solid #eae5e5;
  /* light gray border */
  border-radius: 8px;
  background: #fff;
  height: 400px;
  /* fixed height */
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 6px;
}

/* Inner cards */
.inner-card {
  border: 1px solid #eae5e5;
  border-radius: 6px;
  padding: 8px;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

/* Small avatars for inner cards */
.v-avatar img {
  object-fit: cover;
}

/* Small text for title */
.small-text {
  font-size: 0.9rem;
  line-height: 1.2;
}

/* Small text for description */
.smaller-text {
  font-size: 0.75rem;
  line-height: 1.1;
}

.v-slide-group .v-slide-item {
  min-width: 80%;
  /* card width for carousel slides */
}

.inner-transaction-card {
  height: 100%;
}

/* Text colors */
.text-grey {
  color: #888;
}

.text-red {
  color: #e53935;
}

.text-green {
  color: #43a047;
}

.inner-transaction-card>div:hover {
  background: #f9f9f9;
  border-radius: 6px;
}

.product-card {
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
}

.inner-mini-card {
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  background: #fafafa;
}

.product-image {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  object-fit: cover;
  margin-right: 2%;
}

.clickable-title {
  cursor: pointer;
  transition: 0.2s ease;
}

.clickable-title:hover {
  opacity: 0.7;
}

.modern-input {
  width: 100%;
  height: 46px;
  margin-top: 6px;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  font-size: 15px;
  background: transparent;
  transition: all 0.2s ease;
}

.modern-input:focus {
  outline: none;
  border-color: #000;
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
}


/**Verifiction banner */
.kyc-banner {
  background: #fff3cd;
  border: 1px solid #ffeeba;
  padding: 12px;
  margin-bottom: 16px;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.kyc-btn {
  background: #f59e0b;
  padding: 6px 12px;
  border-radius: 6px;
  color: white;
  font-weight: bold;
}

/* Button */
.action-button {
  width: 100%;
  height: 46px;
  background: #112830;
  color: #fff;
  border-radius: 10px;
  font-weight: 600;
  transition: all 0.25s ease;
}

.action-button:hover {
  background: #292828;
}

.spin {
  animation: spin 1s linear infinite;
}

/* PIN Container */
.pin-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 14px;
  width: 100%;
  margin: 20px 0;
}

/* Individual PIN Box */
.pin-box {
  width: 58px;
  height: 58px;

  border: 1.5px solid #d1d5db;
  border-radius: 12px;

  background: #fff;

  text-align: center;
  font-size: 22px;
  font-weight: 600;
  color: #111827;

  transition: all .25s ease;

  outline: none;
}

/* Focus */
.pin-box:focus {
  border-color: #000;
  box-shadow: 0 0 0 4px rgba(0, 0, 0, .08);
}

/* Filled */
.pin-box:not(:placeholder-shown),
.pin-box:valid {
  border-color: #16a34a;
}

/* Disabled */
.pin-box:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
}

/* Hide number input arrows if type=number */
.pin-box::-webkit-outer-spin-button,
.pin-box::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.pin-box {
  -webkit-text-security: disc;
  text-security: disc;
}

.pin-title {
  text-align: center;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 6px;
}

.pin-subtitle {
  text-align: center;
  color: #6b7280;
  font-size: 13px;
  margin-bottom: 20px;
}

.withdraw-error {
  background: linear-gradient(90deg, #fff5f5 0%, #ffffff 100%);
  border-left: 5px solid #ef4444;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

/* Mobile */
@media (max-width: 600px) {
  .content {
    padding: 0;
  }

  .avatar-mobile {
    width: 32px;
    height: 32px;
  }

  .title-mobile {
    font-size: 0.9rem;
  }

  .icon-mobile {
    font-size: 16px;
  }

  .pin-container {
    gap: 10px;
  }

  .pin-box {
    width: 48px;
    height: 48px;
    font-size: 18px;
    border-radius: 10px;
  }
}
</style>